module.exports = __webpack_public_path__ + "static/media/IMG_20191204_133104.eba431d2.jpg";